import React from "react";

const faqs = [
  {
    title:
      "As a Texan, why should I choose Affordable Debt Consolidation in Texas?",
    content: (
      <>
        <ol className="list-decimal text-gray-800">
          <li className="mb-2">
            Our Texas Debt Relief services are typically 40% less than most
            competitors, especially out-of-state companies. This program is
            exclusively for Texans. Talk to one of our Texas Debt Specialists to
            learn about our advantages and savings over out-of-state
            "cookie-cutter" programs.
          </li>
          <li className="mb-2">
            We provide an affiliate platform to shop many different lenders for
            credit card Debt Consolidation Loans up to $100,000.
          </li>
          <li className="mb-2">
            We also offer an affiliate program to reduce interest rates without
            new loans and our Texas Debt Relief program to negotiate significant
            balance reductions.
          </li>
          <li className="mb-2">
            We can assist if you are facing creditor lawsuits.
          </li>
          <li className="mb-2">
            Phone and office consultations are free with no obligation.
          </li>
          <li className="mb-2">
            Affordable Debt Consolidation is 100% veteran-owned, Texan-owned,
            state-licensed, with an A + Better Business Bureau rating.
          </li>
        </ol>
      </>
    ),
  },
  {
    title: "What are my options to resolve overwhelming debt?",
    content: (
      <>
        <p className="text-gray-800 mb-2">
          Our Texas Debt Specialists assist Texans with multiple programs
          offered by our company and by utilizing a high-rated resource. Our
          Texas Debt Relief program uses Debt Settlement to negotiate
          significant reductions in the amount you pay back to your creditors.
          Credit Counseling programs can lower interest rates on credit card
          debt without a new loan. We also provide our affiliate platform to
          shop dozens of lenders who offer Debt Consolidation Loans to Texas
          residents who qualify. Any of these options will allow you to
          "consolidate" debt with one monthly program amount. We can also
          arrange a free consultation with a highly-rated Texas bankrupcy law
          firm if you would like to compare bankrupcy to non-bankruptcy options.
        </p>
      </>
    ),
  },
  {
    title: "What is your Texas Debt Relief program?",
    content: (
      <>
        <p className="text-gray-800 mb-2">
          Our Texas Debt Relief program is a Debt Settlement program offered
          exclusively to Texans. Debt Settlement is also referred to as Debt
          Negotiation or Debt Resolution. This method resolves your unsecured
          debt by negotiating a lower amount to pay your creditors and settling
          in full with a zero balance. The process involves setting money aside
          in a new special purpose account rather than making small monthly
          payments to your creditors. Each enrolled debt is negotiated and
          settled one at a time using money that accrues in the special purpose
          account until all debts settle with a zero balance remaining. The
          monthly amount you set aside is based on your budget. In some cases,
          it can be less than half compared to making high-interest credit card
          monthly payments.
          <br />
          <br />
          Consultations with a Texas Debt Specialist are entirely free with no
          obligation. Our Texas Debt Relief fees are performance-based, meaning
          clients pay our company no fees until a debt is negotiated and
          settled. Our settlement fees are a flat 15% of your enrolled debt and
          are factored into your new affordable monthly program payment. Most
          Debt Relief companies charge 25% of your enrolled debt, making our
          settlement fees up to 40% LOWER than most other companies. Our fees do
          not include any optional third-party fees administered by a separate
          provider.
        </p>
      </>
    ),
  },
  {
    title:
      "Do you guarantee all my debts will settle at a particular percentage?",
    content: (
      <>
        <p className="text-gray-800 mb-2">
          It is illegal for any company to make such a guarantee. We will
          provide a realistic good-faith estimation using historical industry
          settlements and factoring the specific creditors you owe. We believe
          some companies make unrealistic claims and “bait and switch” their
          clients. These tactics are often uncovered by reading complaints about
          the company. One of the largest out-of-state Debt Relief companies was
          sued by the federal government and several state governments for
          providing unrealistic outcomes. Our goal is for our clients to
          graduate sooner than estimated as much as possible, although some
          clients will be enrolled longer than estimated due to a variety of
          factors. Affordable Debt Consolidation will not give you an
          unrealistic expectation to convince you to enroll. Speak to one of our
          Texas Debt Specialists if you want an honest evaluation. We always
          work hard on your behalf to save you the most money possible.
        </p>
      </>
    ),
  },
  {
    title: "What is Credit Counseling?",
    content: (
      <>
        <p className="text-gray-800 mb-2">
          Credit Counseling is a form of Debt Management that can lower your
          interest rates with credit card debt and some installment loans while
          providing one monthly payment. It is a form of Debt Consolidation that
          does not require a new loan. Credit Counseling and Debt Negotiation
          are both considered hardship programs, but Credit Counseling does not
          negotiate the balances. Only the interest rates are reduced. We can
          help a consultation with a highly-rated non-profit Credit Counselor if
          you want to pursue this option.
        </p>
      </>
    ),
  },
  {
    title: "Do you guarantee the lowest  Debt Settlement fees?",
    content: (
      <>
        <p className="text-gray-800 mb-4 text-md">
          Affordable Debt Consolidation believes we provide Texans with the best
          deal available. Texans designed our Texas Debt Relief program and
          created it exclusively for Texans. Out-of-state companies usually
          charge 25% of your enrolled debt as a “performance” or “contingency”
          fee. Our Texas Debt Relief service is provided with a 15% fee, meaning
          you could easily pay up to 40% higher settlement fees with a
          competitor.
        </p>
        <p className="text-gray-800 mb-4 text-md">
          Since we are a Texas company focused on resolving debt for Texas
          residents, we aim to have low overhead and provide full-service Debt
          Settlement services at a lower cost. We only charge our fees
          proportionate to amount of debt settled after payment is made towards
          the settlement.
        </p>
        <p className="text-gray-800 mb-4 text-md">
          If you are a Texas resident and qualified for our Debt Settlement
          service after a consultation, we will provide you with lower
          performance fees than any licensed and reputable competitor. If we are
          unable to offer lower performance fees than a qualified competitor, we
          will give you a $1,000 Visa gift card with the following simple
          requirements:
        </p>
        <p className="text-gray-800 text-md">
          As state law requires, the competitor is registered with the Texas
          Office of Consumer Credit Commissioner. Fees charged must be
          performance-based. The Better Business Bureau rates the competitor
          “A-” or higher. We have determined that you qualify for our services.
          We receive verifiable written proof of the competing offer. The
          guarantee only applies to fees charged by our company forour Texas
          Debt Relief service and does not apply to any optional third-party
          service. Please speak to one of our Texas Debt Specialists for more
          information.
        </p>
      </>
    ),
  },
  {
    title: "What types of debt do you assist with Debt Relief?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          We can enroll credit cards, unsecured installment loans, personal
          loans, medical bills, department store credit cards and loans, payday
          loans, and most other unsecured debts. We can also assist with many
          lawsuits and judgments. Our program cannot assist with secured debt,
          including home and auto loans unless the collateral has been
          repossessed. Student loans backed by the Department of Education are
          not eligible, but free student loan assistance is available at&nbsp;
          <a
            className="text-blue-800 hover:underline"
            href="https://studentaid.gov"
            target="_blank"
            rel="noreferrer"
          >
            https://studentaid.gov
          </a>
          &nbsp;We do assist with some private student loans and some business
          debt. Speak to one of our Texas Debt Specialists for more information.
        </p>
      </>
    ),
  },
  {
    title:
      "Will I receive calls from creditors or debt collectors using Debt Settlement?",
    content: (
      <>
        <p className="text-gray-800 mb-4 text-md">
          Enrolling in a Debt Settlement program alone will not stop creditors
          or debt collectors from calling you. Even if creditors know they will
          ultimately receive a settlement in full, individual debt collectors
          are usually paid a commission based on the amount they collect from
          you. Therefore, they may call you directly in an attempt to collect
          more money than our negotiators will arrange. Texas has specific
          consumer protection laws that protect you in addition to the federal
          Fair Debt Collection Practices Act. When enforced, the Texas Finance
          Code can prevent nearly all harassment from original creditors in
          addition to third-party debt collectors. Affordable Debt Consolidation
          has made an affordable arrangement to refer clients to whom we feel is
          the top debt defense attorney in Texas. By retaining the attorney,
          separately from our program, it is illegal for debt collectors to call
          you under Texas law. Instead, they will only be authorized to call
          your attorney, or our settlement representatives.
        </p>
        <p className="text-gray-800 mb-4 text-md">
          If you do not hire a separatete attorney, our negotiation team will
          help reduce the number of calls you receive as much as possible.
          However, most creditors and debt collectors will attempt to call you
          until the debts are settled
        </p>
      </>
    ),
  },
  {
    title:
      "Why is a Texas-based Debt Relief company focused on resolving debt for Texans better for me?",
    content: (
      <>
        <p className="text-gray-800 mb-4 text-md">
          Since we only service Texans, we believe we are very efficient at it,
          and we do not have the high national advertising expenses of the
          “national” Debt Relief companies. Therefore we can provide a very high
          level of customer service with settlement fees that are typically up
          to 40% LESS compared to out-of-state companies. We also understand the
          specific consumer protection laws in Texas to help leverage these laws
          to your advantage.
        </p>

        <p className="text-gray-800 mb-4 text-md">
          A scary truth is some out-of-state companies are not licensed in
          Texas. Any Debt Management or Debt Relief company doing business with
          Texas residents and not registered with the Office of Consumer Credit
          Commissioner is in violation of state law. It is not hard to imagine
          how a company that violates the law will treat its clients. Any Debt
          Relief company should also provide an honest and realistic estimation
          of your potential savings and the amount of time it will take to
          resolve the debt.
        </p>

        <p className="text-gray-800 text-md">
          Federal and state law prevents Debt Relief companies from charging
          their fees until after a debt has been settled. When researching any
          company, check the Better Business Bureau report at http://bbb.org{" "}
          <a
            className="text-blue-800 hover:underline"
            href="http://bbb.org"
            target="_blank"
            rel="noreferrer"
          >
            http://bbb.org.
          </a>{" "}
          Read how long the company has been in business, rating, and review any
          complaints filed against the business as this is one item companies
          cannot hide.
        </p>
      </>
    ),
  },
  {
    title:
      "Can a creditor file a lawsuit while enrolled in a Debt Relief program?",
    content: (
      <>
        <p className="text-gray-800 mb-4 text-md">
          To achieve forgiveness of a large portion of debt balances, the debt
          must be delinquent to demonstrate a hardship. While most individual
          debts enrolled do not experience a lawsuit, any time you do not follow
          the original lending agreement, the creditor has the right to use the
          civil court system as a method of debt collection. However, most
          creditor lawsuits can be minimized by prioritizing the settlement of
          debt at risk of a lawsuit. Texas also has very high consumer
          protection laws compared to most other states, making it difficult or
          impossible for a creditor to collect a judgment in many situations,
          making this method of debt collection much less attractive to
          creditors. Lawsuits are not the preferred method of collecting a debt
          for any creditor. We have extensive experience with this method of
          debt collection in Texas, as we enroll many clients with pre-existing
          lawsuits.
        </p>
        <p className="text-gray-800 mb-4 text-md">
          Many of our clients choose a referral to who, in our opinion, is the
          best debt defense attorney in Texas. The advantage of having the
          attorney retained upfront is that creditors will understand that you
          will have legal representation, providing additional protection to
          minimize lawsuits. The attorney will also take action in an attempt to
          avoid a lawsuit whenever necessary. If a creditor files a lawsuit, the
          Texas debt defense attorney will represent you and protect your best
          interest.
        </p>
        <p className="text-gray-800 mb-4 text-md">
          If you retain a separate attorney, the law firm will also protect you
          from creditor harassment while your debts are resolved throughout our
          debt settlement process. This can help reduce stress during the Debt
          Settlement process.
        </p>
        <p className="text-gray-800 text-md">
          Alternatively, we can provide a reactionary-only “pre-paid legal” or
          “legal insurance” similar to what is offered by many competitors. The
          low-cost plan will not provide the same harassment protection as
          retaining a debt defense attorney directly but will find and cover the
          cost of an attorney to represent you if you experience a lawsuit while
          enrolled.
        </p>
      </>
    ),
  },
  {
    title: "Do I include all my debt in your Texas Debt Relief program?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          Clients usually enroll all unsecured debts with balances over $1,000.
          You may keep out an unsecured debt with a balance under $1,000 if it
          remains under $1,000 while enrolled. You may also keep out credit
          cards that you can pay down and keep under $1,000 within six months of
          enrollment. If enrolled creditors see that you can pay other accounts
          with significant balances, it could make it more difficult for your
          negotiator to obtain the highest possible savings for you. Your Texas
          Debt Specialist will discuss any exceptions after reviewing your
          creditors and situation.
        </p>
      </>
    ),
  },
  {
    title: "Where are my funds for settlement held?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          We utilize an A+-rated third-party company called Forth. Funds are
          held in your FDIC special-purpose custodial account to fund
          settlements and pay our performance fees when they are due. We only
          collect performance fees after settling a debt and at least one
          payment is made towards the new negotiated balance.
        </p>
      </>
    ),
  },
  {
    title: "Will I owe any taxes on the forgiven amounts?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          Sometimes creditors may send you a 1099-C for the debt amount
          forgiven, which the IRS could consider a taxable income. The IRS
          provides Form 982 Reduction of Tax Attributes due to Discharge of
          Indebtedness. Depending on your assets, this form may exempt you from
          owing any taxes on the forgiven debt. According to IRS.gov “A taxpayer
          is insolvent when his or her total liabilities exceed his or her total
          assets. The forgiven debt may be excluded as income under the
          ‘insolvency’ exclusion. Normally, a taxpayer is not required to
          include forgiven debts in income to the extent that the taxpayer is
          insolvent.” We recommend speaking with your tax advisor if you receive
          a 1099-C.
        </p>
      </>
    ),
  },
  {
    title: "Do interest and late fees accrue on my accounts?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          Creditors will add some interest and possibly late fees onto your
          balances for at least the first few months of delinquency. We factor
          this additional amount upfront into our program estimations. Any
          amount added is included as part of the settlement, and you only pay
          performance fees based on your enrolled balances. It is important to
          keep in mind that interest is going to continue to accrue on your
          debts regardless of whether you are making your minimum monthly
          payments or not, although it will compound for time if when not making
          payments.
        </p>
      </>
    ),
  },
  {
    title: "Can I negotiate my own debt?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          Yes. Some people elect to do their taxes, make significant repairs to
          their homes, and service their vehicles. Most people prefer to have
          experts in the field handle these tasks. It is possible to make
          mistakes and debt collectors then go after the total balances. Dealing
          with professional debt collectors can be very stressful for someone
          who is not trained and does not do so daily. In addition to the time,
          effort, and knowledge that you need, an experienced debt negotiator
          may have the ability to obtain lower settlements. The debt collectors
          who deal with consumers are highly trained to get the most money
          possible and usually receive a commission based on the amount they can
          collect from you. Our negotiators often speak to separate
          business-to-business representatives with the creditors and collection
          agencies on a professional level. Sometimes our negotiators also
          leverage multiple debts owed by multiple clients to negotiate “bulk”
          savings. If you would like to negotiate debt on your own, our Texas
          Debt Specialists will provide you with resources to help you succeed
          at no charge.
        </p>
      </>
    ),
  },
  {
    title: "When do negotiations begin with my creditors?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          Each debt is negotiated one at a time as money accrues in your special
          purpose account. Negotiations usually begin at about six months into
          the program since this is when most creditors are willing to offer our
          negotiators substantial reductions of your balances. Exactly when
          negotiations start depends on how your program is structured, the
          status of your debts upon enrollment, and the creditors owed. You will
          receive documents verifying each settlement. Once the settlement is
          fulfilled, you will owe a zero balance on the settled debt.
        </p>
      </>
    ),
  },
  {
    title: "How long will my Texas Debt Relief program last?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          Depending on your monthly budget, we usually estimate our programs
          anywhere from 24 months to 48 months, although we have had clients
          with the ability to complete a program in as little as three months.
          In extreme hardship cases, we will sometimes estimate programs out to
          72 months to provide the lowest possible monthly program payment. Any
          Debt Negotiation program can be longer or shorter than estimated
          depending on the amounts of the final settlements. If you only make
          the minimum payments, you might stay in debt for the next 10 or 20+
          years. Assuming you do not make any more charges on your credit cards,
          just only making minimum payments could still cost you 2x, 3x, or even
          4x as much as you originally borrowed. Your credit card statements
          will disclose how long it will take to pay off the debt by only making
          minimum payments.
        </p>
      </>
    ),
  },
  {
    title:
      "Should I consider your Texas Debt Relief program instead of bankruptcy?",
    content: (
      <>
        <p className="text-gray-800 mb-4 text-md">
          We believe most Texans want to consider bankruptcy as a last resort.
          If you qualify, Chapter 7 bankruptcy can be a quick way to eliminate
          unsecured debt. It will remain on your credit report for ten years
          after Chapter 7 is discharged or seven years after a
          three-to-five-year repayment plan from Chapter 13. Bankruptcy may
          affect your qualification for employment, some licensing, insurance,
          and your qualification to buy a house after the discharge. It is also
          important to understand that bankruptcy is a public record and can
          easily be found in background checks potentially for the rest of your
          life.
        </p>

        <p className="text-gray-800 text-md">
          After the bankruptcy laws changed years ago, many more people could
          not qualify for Chapter 7 due to their income and assets. Under
          Chapter 13 bankruptcy, your debt repayment is restructured. This means
          you will pay either a portion or all of your debt while still
          suffering the consequences of bankruptcy. Debt Negotiation is an
          excellent alternative to a Chapter 13 bankruptcy in many cases. In
          some cases, the Debt Negotiation program can cost less than Chapter
          13, and in other cases, it could cost more. We are not a law firm, and
          we do not provide legal advice. We have a special arrangement with a
          very experienced Texas bankruptcy law firm to provide statewide
          bankruptcy services. The law firm can help you obtain an honest
          comparison of bankruptcy to non-bankruptcy options, such as our Texas
          Debt Relief program.
        </p>
      </>
    ),
  },
  {
    title: "When should I obtain expert help to resolve my debt?",
    content: (
      <>
        <p className="text-gray-800 text-md">
          Many of our clients have accumulated tens of thousands or hundreds of
          thousands of high-interest unsecured debt such as credit cards or
          personal loans. Some were barely able to cover the minimum payments or
          have already fallen behind. The financial hardship can be caused by
          income loss, divorce, high-interest rates, the Pandemic, or simply due
          to inflation. If you are making your minimum payments but have no
          savings, investments, or retirement because of never-ending debt
          payments, talk to one of our Texas Debt Specialists today. If you
          haven’t made payments in months and perhaps even face lawsuits from
          your creditors, we can also provide affordable help. Your Texas Debt
          Specialist will learn about your unique situation and discuss multiple
          options to resolve your debt as quickly and affordably as possible.
        </p>
      </>
    ),
  },
  {
    title: "Do you lend money to pay debt?",
    content: (
      <>
        <p className="text-gray-800 mb-2">
          Affordable Debt Consolidation is not a lender. We offer an affiliate
          platform to shop dozens of lenders who provide credit card Debt
          Consolidation Loans to qualified Texas residents. This is separate
          from our Texas Debt Relief services. Shopping multiple lenders with
          our affiliate platform is free, and it will give you an advantage over
          applying with an individual lender. Another benefit is that reviewing
          the offers from many lenders will not impact your credit score. If you
          have been previously unable to qualify for a Debt Consolidation Loan,
          speak to one of our Texas Debt Specialists about our affiliate
          platform or about options to resolve debt without the need for any new
          loans. Our Texas Debt Relief programs often provide a monthly program
          payment of less than half compared to high-interest minimum payments,
          or a credit counseling program could reduce interest rates without a
          new loan.
        </p>
      </>
    ),
  },
];

const trackingCodes = {
  wfaaMetaPixel: "1120168652929094",
};

export { faqs, trackingCodes };
